import React from "react";
import Text from "../Text/Text";
interface Props {
  text: string;
  img: string;
  widthImg: string;
  heightImg: string;
}
function EmptyData({ text, img, widthImg, heightImg }: Props) {
  return (
    <div
      style={{ display: "grid", justifyContent: "center", alignItems: "center", padding: "10%" }}
    >
      <img src={img} style={{ width: widthImg, height: heightImg }} />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "12px",
        }}
      >
        <Text fontSize={18} color='Text1'>
          {text}
        </Text>
      </div>
    </div>
  );
}

export default EmptyData;
